import React from 'react';
import { List, Item } from './style';
import FinancingSolution from '../FinancingSolution';

const THEMES = ['YELLOW', 'PURPLE', 'GREEN'];

const FinancingSolutions = ({ financingSolutions }) => (
  <>
    <List>
      {financingSolutions.map((financingSolution, i) => (
        <Item key={financingSolution.title}>
          <FinancingSolution financingSolution={financingSolution} theme={THEMES[i]} />
        </Item>
      ))}
    </List>
  </>
);

export default FinancingSolutions;
